import React from 'react';

function EPCoupons() {
  return (
    <div>EPCoupons</div>
  );
}

export default EPCoupons;
